const breadCrumb = "Lotação de Servidores - Manutenção do Servidor";
const parentRoute = "/cadastro-de-servidor";

const routes = [
  {
    path: "/servidor/:servidorId/manutencao-de-informacoes-do-servidor",
    name: "manutencao-de-informacoes-do-servidor",
    meta: {
      allowedPermissions: ["habilitacao_list"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Informações do Servidor",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoDeInformacoesDoServidor/ManutencaoDeInformacoesDoServidorHome.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/manutencao-de-informacoes-do-servidor/novo",
    name: "manutencao-de-informacoes-do-servidor-novo",
    meta: {
      allowedPermissions: ["habilitacao_insert"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Informações do Servidor - Novo",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoDeInformacoesDoServidor/ManutencaoDeInformacoesDoServidorCad.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/manutencao-de-informacoes-do-servidor/editar/:id",
    name: "manutencao-de-informacoes-do-servidor-editar",
    meta: {
      allowedPermissions: ["habilitacao_update"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Informações do Servidor - Editar",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoDeInformacoesDoServidor/ManutencaoDeInformacoesDoServidorEdit.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/manutencao-de-informacoes-do-servidor/visualizar/:id",
    name: "manutencao-de-informacoes-do-servidor-visualizar",
    meta: {
      allowedPermissions: ["habilitacao_show"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Informações do Servidor - Visualizar",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoDeInformacoesDoServidor/ManutencaoDeInformacoesDoServidorShow.vue"
      ),
  },
];

export default routes;
